const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://redi.dvgeo.app' : 'http://192.168.100.104:3076',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://redi.dvgeo.app' : 'http://192.168.100.104:3076',
    api: 'api/',
    apiSocket: 'redi::1.2',
    nameDir: 'redi',
    package: 'ec.redi.web',
    version: '1.0.1',
    googleAPIKey: 'AIzaSyAV3ILe1k7CzaseKjTQdXkDB5HHGCCgDW8',
    appName: 'REDI',
    provider: '',
    colorPrimary: '#f2b93b',
    colorDark: '#000000',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'ec.redi.passenger',
    playStoreDriverId: 'ec.redi.driver',
    appStorePassengerId: '6755795404',
    appStoreDriverId: '6755793773',
};
export default config;
